<template>
  <div class="course-module">
    <div class="d-flex justify-content-between">
      <h6 class="text-primary">Course Module</h6>
      <CButton
        class="btn-primary small mr-2"
        style="height: 28px"
        v-c-tooltip="'Click to Add new Module!'"
        @click="addNewModule"
        >Add</CButton
      >
    </div>
    <div
      class="mt-2 border-dotted-bottom d-flex justify-content-between"
      v-for="(courseModule, index) in courseModules"
      :key="index"
    >
      <div class="module-record">
        <CRow>
          <CCol md="4">
            <CRow class="mb-3">
              <label class="col-lg-12 col-md-12 required">Module No.</label>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <Select
                    name="module_no"
                    :value="courseModule.module_no"
                    :options="
                    options && options['moduleNumbers'] ? options['moduleNumbers'] : []
                  "
                    @change="
                    (name, value) => handleChangeSelect(name, value, index)
                  "
                :multiple="false"
                :clearable="true"
                  />
                </ValidationProvider>
              </div>
            </CRow>
          </CCol>
          <CCol md="4">
            <CRow class="mb-3">
              <label class="col-lg-12 col-md-12 required">Title</label>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <TextInput
                    name="module_title"
                    :value="courseModule.module_title"
                    @input="
                      (name, value) => handleInputMulti(name, value, index)
                    "
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </div>
            </CRow>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12">
            <CRow class="mb-3">
              <label class="col-lg-12 col-md-12">Content</label>
              <div class="col-lg-12 col-md-12">
                <TextAreaInput
                  name="module_content"
                  :value="courseModule.module_content"
                  @input="(name, value) => handleInputMulti(name, value, index)"
                />
              </div>
            </CRow>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4">
            <CRow class="mb-3">
              <label class="col-lg-12 col-md-12">Related Test</label>
              <div class="col-lg-12 col-md-12">
                <RadioButton
                  name="related_test"
                  :value="courseModule.related_test"
                  :options="
                    options && options['boolean'] ? options['boolean'] : []
                  "
                  @change="
                    (name, value) => handleRadioButtonMulti(name, value, index)
                  "
                />
              </div>
            </CRow>
          </CCol>
          <CCol md="4">
            <CRow class="mb-3">
              <label class="col-lg-12 col-md-12">Required Test Score</label>
              <div class="col-lg-12 col-md-12">
                <ValidationProvider rules="numeric" v-slot="{ errors }">
                  <TextInput
                    name="required_test_score"
                    :value="courseModule.required_test_score"
                    type="number"
                    @input="
                      (name, value) => handleInputMulti(name, value, index)
                    "
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </div>
            </CRow>
          </CCol>
          <CCol md="4">
            <CRow class="mb-3">
              <label class="col-lg-12 col-md-12">Required Test Percent</label>
              <div class="col-lg-12 col-md-12">
                <ValidationProvider rules="numeric" v-slot="{ errors }">
                  <TextInput
                    name="required_test_percent"
                    :value="courseModule.required_test_percent"
                    type="number"
                    @input="
                      (name, value) => handleInputMulti(name, value, index)
                    "
                    :error="errors[0]"
                  />
                </ValidationProvider>
              </div>
            </CRow>
          </CCol>
        </CRow>
      </div>
      <div>
        <CButton
          class="icon mr-1"
          v-if="index > 0"
          @click="deleteModule(index)"
          v-c-tooltip="'Click to Delete this module!'"
        >
          <i class="fas fa-trash-alt" />
        </CButton>
      </div>
    </div>
    <Modal
      v-if="deleteConfirmModal.isShowPopup"
      :modalTitle="deleteConfirmModal.modalTitle"
      :modalColor="deleteConfirmModal.modalColor"
      :modalContent="deleteConfirmModal.modalContent"
      :isShowPopup="deleteConfirmModal.isShowPopup"
      :buttons="deleteConfirmModal.buttons"
      :modalCallBack="deleteModalCallBack"
      :closeOnBackdrop="false"
    />
  </div>
</template>
<script>
import Vue from "vue";
import courseMixin from "@/containers/Course/AddCourse/courseMixin.js";
export default {
  name: "CourseModule",
  mixins: [courseMixin],
  data() {
    return {
      deleteConfirmModal: {
        modalColor: "danger",
        modalTitle: "NOTIFICATION",
        modalContent: "",
        isShowPopup: false,
        buttons: ["Cancel", "Confirm"],
        data: null,
      },
    };
  },
  computed: {
    options() {
      return {
        boolean: [
          { code: true, label: "Yes" },
          { code: false, label: "No" },
        ],
        moduleNumbers : this.courseModuleNumbers
      };
    },
    courseModuleNumbers() {
      const points = Array.from({ length: 250 }, (_, i) => i + 1).map((v) => ({
        code: v,
        label: v,
      }));
      return points;
    },
  },
  methods: {
    handleInputMulti(name, value, index) {
      Vue.set(this.courseModules[index], name, value);
      this.payload.courseModules[index][name] = value;
      this.updateParentData();
    },
    handleRadioButtonMulti(name, value, index) {
      let val = null;
      if (value === null) {
        val = null;
      } else if (value.id === false || value.code === false) {
        val = false;
      } else if (value.id === null || value.code === null) {
        val = null;
      } else {
        val = value.id || value.code || value;
      }
      Vue.set(this.courseModules[index], name, val);
      this.payload.courseModules[index] = {
        ...this.payload.courseModules[index],
        [name]: val,
      };
      this.updateParentData();
    },
    handleChangeSelect(name, value, index) {
      Vue.set(this.courseModules[index], name, value);
      let val = value?.code;
      this.payload.courseModules[index][name] = val;
      this.updateParentData();
    },

    deleteModule(index) {
      this.deleteConfirmModal.modalTitle = "NOTIFICATION";
      this.deleteConfirmModal.modalContent =
        "Are you sure you want to delete this Module?";
      this.deleteConfirmModal.isShowPopup = true;
      this.deleteConfirmModal.data = index;
    },
    deleteModalCallBack(action) {
      if (action === "Confirm") {
        const { data } = this.deleteConfirmModal;
        this.courseModules.splice(data, 1);
      }
      this.deleteConfirmModal.isShowPopup = false;
      this.deleteConfirmModal.data = null;
    },
    updateParentData(){      
      const formName ="courseModules"
      this.$emit("syncData", formName, this.payload[formName] )
    }
  },
};
</script>
<style lang="scss" scoped>
.module-record {
  min-width: 98%;
}
</style>
